import React, { PureComponent, ReactNode } from "react";
import Navbar from "../../../components/CustomNav/CustomNav.Component";

import { currentUser } from "src/common/services";
import { Container } from "src/pages/Teachers/TeacherMenu.styles";
import { PickerHeader } from "../CourseDetails/CourseDetails.styles";
import { HeaderRow } from "../DataCentre.styles";
import DatePicker from "../../../components/DatePicker/DatePickerComponent";
import { toast } from "react-toastify";
import withServices from "../../../HOCs/withServices";
import {
  LearnersRow,
  GradientList,
  GradientListItem,
} from "../School/QuickGlance/QuickGlance.styles";
import Loader from "react-loader";

interface Props {
  history: any;
  services: any;
}
interface State {
  startDateObj: unknown;
  endDateObj: unknown;
  leastActiveLearners: any;
  inactiveLearners: any;
  mostActiveLearners: any;
  startDate: string;
  endDate: string;
  loading: boolean;
  yeargroup: string;
  yearGroups: [];
}

const learners = [
  "Breburn Learner 1",
  "Breburn Learner 2",
  "Breburn Learner 3",
  "Breburn Learner 4",
  "Breburn Learner 5",
  "Breburn Learner 6",
];

class LearnerActivity extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      startDateObj: null,
      endDateObj: null,
      leastActiveLearners: [] as any,
      inactiveLearners: [] as any,
      mostActiveLearners: [] as any,
      startDate: "",
      endDate: "",
      loading: false,
      yeargroup: "",
      yearGroups: [],
    };

    this.fetchLearnerActivity = this.fetchLearnerActivity.bind(this);
    this.onYeargroupChange = this.onYeargroupChange.bind(this);
  }

  public async componentDidMount() {
    const {
      // match,
      history,
      // location,
      services: { isUserLoggedIn, institutionsAPI, currentUserID },
    } = this.props;

    if (!isUserLoggedIn) {
      history.replace("/login");
      return;
    }

    const res = await institutionsAPI.getInstitutionYearGroups(currentUserID);
    console.log({ res });
    if (res.ok) {
      this.setState({ yearGroups: res.data.year_groups });
    }
  }

  public onStartDateChange = (dateObj) => {
    const date = `${dateObj.year}-${dateObj.month}-${dateObj.day}`;
    this.setState({ startDateObj: dateObj, startDate: date });
  };

  public onEndDateChange = (dateObj) => {
    const date = `${dateObj.year}-${dateObj.month}-${dateObj.day}`;
    this.setState({ endDateObj: dateObj, endDate: date });
  };

  public async fetchLearnerActivity() {
    this.setState({ loading: true });
    const { startDate, endDate, yeargroup } = this.state;
    const {
      services: { institutionsAPI },
    } = this.props;
    if (!startDate.length || !endDate.length) {
      toast.warn("Please make sure you have picked the correct date ranges");
      return;
    }

    const leastRes = await institutionsAPI.getLeastActiveLearners(
      startDate,
      endDate,
      yeargroup
    );
    const inactiveRes = await institutionsAPI.getInactiveLearners(
      startDate,
      endDate,
      yeargroup
    );

    const mostActiveRes = await institutionsAPI.getMostActiveLearners(
      startDate,
      endDate,
      yeargroup
    );

    console.log({ inactiveRes, leastRes, mostActiveRes });
    this.setState({
      loading: false,
      inactiveLearners: inactiveRes.data.inactive_learners,
      leastActiveLearners: leastRes.data.least_active_learners,
      mostActiveLearners: mostActiveRes.data.most_active_learners,
    });
  }

  public onLogout = () => {
    this.props.history.replace("/login");
  };

  public onYeargroupChange(e) {
    this.setState({ yeargroup: e.target.value });
    // this.fetchLearnerActivity();
  }

  public render(): ReactNode {
    const {
      loading,
      endDate,
      startDate,
      yearGroups,
      inactiveLearners,
      leastActiveLearners,
      mostActiveLearners,
    } = this.state;
    return (
      <Container>
        <Navbar logoutParent={this.onLogout} />
        <h1 className="menu-heading">
          Hey <span>{currentUser()}</span>
        </h1>
        <PickerHeader style={{ marginBottom: "4em" }}>
          <HeaderRow>
            <DatePicker
              value={this.state.startDateObj}
              onChange={this.onStartDateChange}
              placeholder="Pick a start date"
            />
            <DatePicker
              value={this.state.endDateObj}
              onChange={this.onEndDateChange}
              placeholder="Pick an end date"
            />
            {endDate.length && startDate.length && yearGroups.length ? (
              <select
                style={{ marginTop: ".75em" }}
                placeholder="Pick a yeargroup"
                name="yeargroup"
                id="yeargroup"
                className="custom-select"
                onChange={this.onYeargroupChange}
              >
                <option value="">Pick a year group (optional)</option>
                {yearGroups.map((y, i) => (
                  <option key={`year_group_${i}`} value={y}>
                    {y}
                  </option>
                ))}
              </select>
            ) : (
              ""
            )}
            <button
              onClick={this.fetchLearnerActivity}
              className="button green-button go-action"
            >
              GO
            </button>
          </HeaderRow>
        </PickerHeader>
        {inactiveLearners.length ||
        leastActiveLearners.length ||
        mostActiveLearners.length ? (
          <>
            <LearnersRow padding="4em 2em" justify="center">
              {" "}
              <p className="note">
                Note: Lists are shown in ranking order so top of least active
                list may appear at bottom of most active
              </p>
            </LearnersRow>

            <LearnersRow>
              <div className="learners-row">
                <GradientList>
                  <h3 className="list-title">Inactive Learners</h3>
                  <p className="help-text">
                    From your learners who have access to online pathways, this
                    list shows learners who have not yet engaged with their
                    online learning pathways by logging into them.
                  </p>
                  {inactiveLearners.length ? (
                    inactiveLearners.map((learner, i) => (
                      <GradientListItem
                        highlightColor={`#ff0033`}
                        key={`top5_${learner.userid}_${i}`}
                      >
                        {learner.name}
                      </GradientListItem>
                    ))
                  ) : (
                    <p className="list-empty">No learners fit this category</p>
                  )}
                </GradientList>

                <GradientList>
                  <h3 className="list-title">Least Active Learners</h3>
                  <p className="help-text">
                    This is a list of the learners who have logged in to their
                    online pathways but have the lowest engagement with their
                    pathways.
                  </p>
                  {leastActiveLearners.length ? (
                    leastActiveLearners.map((learner, i) => (
                      <GradientListItem
                        highlightColor={`#ff7a03`}
                        key={`top5_${learner.userid}_${i}_least`}
                      >
                        {learner.name}
                      </GradientListItem>
                    ))
                  ) : (
                    <p className="list-empty">No learners fit this category</p>
                  )}
                </GradientList>

                <GradientList>
                  <h3 className="list-title">Most Active Learners</h3>
                  <p className="help-text">
                    This is a list of the learners who have logged in to their
                    online pathways and have the highest engagement with their
                    online pathways.
                  </p>
                  {mostActiveLearners.length ? (
                    mostActiveLearners.map((learner, i) => (
                      <GradientListItem
                        highlightColor={`var(--green)`}
                        key={`top5_${learner.userid}_${i}_most`}
                      >
                        {learner.name}
                      </GradientListItem>
                    ))
                  ) : (
                    <p className="list-empty">No learners fit this category</p>
                  )}
                </GradientList>
              </div>
            </LearnersRow>
          </>
        ) : (
          ""
        )}
        {loading ? <Loader color="#acff24" /> : ""}
      </Container>
    );
  }
}

export default withServices(LearnerActivity);



// WEBPACK FOOTER //
// ./src/pages/DataCenter/School/SchoolLearnerActivity.tsx